/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  MainLayout,
  Header,
  Drawer,
  CustomRouter,
  Breadcrumbs,
  ComponentLoader,
  ToastContainer,
  getUserAccessRoutes,
} from "@techzyapp/ui-lib";
import { useAuth } from "stores/auth";
import { getTokenFromLocalStorage } from "utils/helpers/auth";
import { authRoutes, allRoutes } from "routes";
import { MainLogo } from "components";

import userSrc from "assets/images/user.png";

import "assets/css/styles.css";

const App = () => {
  const navigate = useNavigate();

  const { getUser, logout, stopUserLoading, user, getUserLoading } = useAuth();

  useEffect(() => {
    const token = getTokenFromLocalStorage();

    if (user?.isBlocked) logout();

    if (token) getUser().catch();
    else stopUserLoading();
  }, []);

  let routes = allRoutes;

  if (getUserLoading) {
    return <ComponentLoader componentType="page" />;
  } else {
    if (user?.accessKeys?.length)
      routes = getUserAccessRoutes(allRoutes, user.accessKeys);
  }

  return (
    <>
      {user ? (
        <MainLayout
          drawer={
            <Drawer
              routes={routes}
              logo={<MainLogo />}
              logoAltText="Silk"
              openFirstLevel
            ></Drawer>
          }
          header={
            <Header
              fullscreen={true}
              languages={false}
              user={{
                name: `${user.firstName} ${user.lastName}`,
                image: userSrc,
                secondaryLabel: user.email,
                menuItems: [
                  {
                    icon: "Lock",
                    label: "Change Password",
                    onClick: () => navigate(`/account`),
                  },
                ],
                onLogout: () => logout(),
              }}
            />
          }
          breadcrumbs={<Breadcrumbs routes={routes} />}
        >
          <CustomRouter routes={routes} />
        </MainLayout>
      ) : (
        <>
          <CustomRouter routes={authRoutes} />
          <ToastContainer />
        </>
      )}
    </>
  );
};

export default App;
